import React from 'react';

import { ProductButtonProps } from '../..';
import { BatchTicketButton } from '../../components/BatchTicketButton';

export const CoesButton: React.FC<ProductButtonProps<'coes'>> = (props) => {
  return <BatchTicketButton {...props} idSelector="productId" />;
};
